import React from "react"
import moment from "moment"
import { getNameUserById } from "../../../../utils/utils"

const getStatus = ({ direction, sent, delivered, read, failed, internal }) => {
    if (internal) return { key: "internal", label: "Nota interna" }
    if (direction !== "send") return { key: "received", label: "Recebida" }
    if (failed) return { key: "failed", label: "Falha no envio" }
    if (read) return { key: "read", label: "Lida" }
    if (delivered) return { key: "delivered", label: "Entregue" }
    if (sent) return { key: "sent", label: "Enviada" }
    return { key: "sending", label: "Enviando" }
}

const MessageFooter = React.memo(
    ({
        created_at,
        edited,
        direction,
        sent,
        delivered,
        read,
        failed,
        internal,
        error,
        confirmationPending,
        acceptancePending,
        styles,
        getIcon = () => { },
        allUsersGroup
    }) => {
        const errorMessage = error || "Não foi possível enviar esta mensagem. Tente reenviar ou revise a conversa."
        const status = confirmationPending
            ? { key: 'confirmation_pending', label: 'Aguardando confirmação do envio' }
            : acceptancePending ? { key: 'accepted', label: 'Envio aceito pelo WhatsApp' }
                : getStatus({ direction, sent, delivered, read, failed, internal })
        const statusIcon = getIcon(
            direction,
            sent,
            delivered,
            read,
            failed,
            internal,
            styles
        )

        return (
            <div className={styles.footer} data-message-status={status.key}>
                {edited?.status && (
                    <span className={styles.italicText}>
                        Editada{" "}
                        {edited?.user_id
                            ? `por ${getNameUserById(allUsersGroup, edited.user_id)}`
                            : ""}
                    </span>
                )}

                <time className={styles.date} dateTime={moment(created_at).isValid() ? moment(created_at).toISOString() : undefined}>
                    {moment(created_at).format("HH:mm")}
                </time>

                {confirmationPending ? (
                    <span role="status" title="O envio pode ter sido aceito. Confira o atendimento antes de enviar outra mensagem.">
                        Aguardando confirmação
                    </span>
                ) : acceptancePending ? (
                    <span role="status" title="O WhatsApp aceitou o envio. A atualização dos detalhes está pendente.">
                        Envio aceito
                    </span>
                ) : failed ? (
                    <span
                        className={styles.messageErrorStatus}
                        tabIndex={0}
                        role="status"
                        aria-label={`Falha no envio: ${errorMessage}`}
                        title={status.label}
                    >
                        {statusIcon}
                        <span className={styles.messageErrorTooltip} role="tooltip">
                            <strong>Falha no envio</strong>
                            <span>{errorMessage}</span>
                        </span>
                    </span>
                ) : (
                    <span className={styles.messageStatusIcon} role="img" aria-label={status.label} title={status.label}>
                        {statusIcon}
                    </span>
                )}
            </div>
        )
    }
)

export default MessageFooter
